import { useCallback } from 'react';
import { GroupTagUpdateItem } from '@trinity/chat';
import { getLocationFor } from '@trinity/chat-components/utils';
import List from './Tags.List';
import { useNavigate } from '@trinity/chat-components/containers/Chat/RoutingProvider';

export default function Readonly() {
  const navigate = useNavigate();

  const handleClick = useCallback((tag: GroupTagUpdateItem) => {
    const location = getLocationFor.workspaces.search({
      keywords: [tag.name],
    });
    navigate(location);
  }, [navigate]);

  return <List onClick={handleClick} />;
}

export { Readonly };